import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type StandardToPremiumIncentiveOfferModalComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{ onClose: (extraInformation?: unknown) => void },
	Record<string, never>
>;

export const entryPoint: EntryPoint<StandardToPremiumIncentiveOfferModalComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<StandardToPremiumIncentiveOfferModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-to-premium-incentive-offer-modal" */ './standard-to-premium-incentive-offer-modal',
			{
				moduleId: 'edition-awareness-standard-to-premium-incentive-offer-modal',
			},
		),
		getPreloadProps: () => ({
			entryPoints: {},
			extraProps: {},
			queries: {},
		}),
	});
